// El <input type="date"> nativo del navegador tiene un bug: al terminar de
// tipear el día/mes y pasar al año, lo traba en 1900 (confirmado que no es
// cosa de React — pasa igual con value, defaultValue o bloqueando el
// re-render). Por eso en toda la app los campos de fecha son texto con
// máscara automática (dd/mm/aaaa) en vez del input nativo, y se convierten
// a ISO (yyyy-mm-dd, lo que esperan los backends) recién al cargar/enviar.

// Va en el onChange de un <input> de fecha: agrega los "/" solo.
export const formatearFechaInput = (value) => {
const digits = value.replace(/\D/g, '').slice(0, 8);
if (digits.length > 4) return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
if (digits.length > 2) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
return digits;
};

// ISO (yyyy-mm-dd) -> texto para mostrar (dd/mm/aaaa).
export const isoAFechaDisplay = (iso) => {
const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
if (!m) return iso || '';
return `${m[3]}/${m[2]}/${m[1]}`;
};

// Texto tipeado (dd/mm/aaaa) -> ISO (yyyy-mm-dd), o null si no es una fecha
// válida (ej. 31/02/2026).
export const fechaDisplayAIso = (valor) => {
const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec((valor || '').trim());
if (!m) return null;
const dd = parseInt(m[1], 10);
const mm = parseInt(m[2], 10);
const yyyy = parseInt(m[3], 10);
const date = new Date(yyyy, mm - 1, dd);
const esValida = date.getFullYear() === yyyy && date.getMonth() === mm - 1 && date.getDate() === dd;
if (!esValida) return null;
return `${yyyy}-${String(mm).padStart(2, '0')}-${String(dd).padStart(2, '0')}`;
};
